import React from 'react';
import { Modal, Table, Button, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FormatPartFormConfig from '../pages/line/details/FormatPartFormConfig';
import CardForm from './form/CardForm';

// Mock data for demonstration
const mockPartData = {
    id: '345',
    createdDate: '2024-03-20',
    formatId: '343434',
    name: 'Sample Part',
    contactWithProduct: true,
    installationNumber: 'INST-789',
    comment: 'Sample comment for the part',
    files: ['/assets/img/sample-part.jpg']
};

const mockHistory = [
    { 
        date: '2024-03-20', 
        user: 'John Doe',
        action: 'Installed',
        line: 'Bosch',
        machineName: 'Bosch',
        details: 'Part installed on line'
    },
    { 
        date: '2024-03-21', 
        user: 'Jane Smith',
        action: 'Cleaning',
        line: 'Bosch',
        machineName: 'Bosch',
        details: 'Part cleaned'
    },
    { 
        date: '2024-03-22', 
        user: 'Mike Johnson',
        action: 'Service',
        line: 'Bosch',
        machineName: 'Bosch',
        details: 'Part moved to service'
    }
];

const PartInfoModal = ({ show, onHide }) => {
    const { t } = useTranslation();
    const baseConfig = FormatPartFormConfig(t);

    // Extend the form configuration with additional fields
    const extendedConfig = {
        ...baseConfig,
        fields: [
            {
                name: "id",
                label: "Part ID",
                column: 1,
                readOnly: true
            },
            {
                name: "createdDate",
                label: "Created Date",
                column: 1,
                readOnly: true
            },
            {
                name: "formatId",
                label: "Format ID",
                column: 1,
                readOnly: true
            },
            ...baseConfig.fields
        ]
    };

    const handleClean = () => {
        // Handle clean action
        console.log('Clean action');
    };

    const handleMoveToService = () => {
        // Handle move to service action
        console.log('Move to service action');
    };

    const handleMoveToDimensioning = () => {
        // Handle move to dimensioning action
        console.log('Move to dimensioning action');
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>{t('Part Information')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-4">
                    <Row>
                        <CardForm
                            size={6}
                            shadow={false}
                            readOnly={true}
                            fields={extendedConfig}
                            initialData={mockPartData}
                            onSubmit={() => { }}
                            onCancel={() => { }}
                            onDelete={() => { }}
                            onAdd={() => { }}
                        />
                        <Col md={6} className="d-flex align-items-center">
                            <div className="d-flex flex-column gap-4 w-100 px-3">
                                <Button 
                                    variant="primary" 
                                    size="lg" 
                                    onClick={handleClean}
                                    className="w-100 py-3 mb-4"
                                >
                                    <i className="fas fa-broom mr-2"></i>
                                    Clean
                                </Button>
                                <Button 
                                    variant="warning" 
                                    size="lg" 
                                    onClick={handleMoveToService}
                                    className="w-100 py-3 mb-3"
                                >
                                    <i className="fas fa-tools mr-2"></i>
                                    Move to Service
                                </Button>
                                <Button 
                                    variant="info" 
                                    size="lg" 
                                    onClick={handleMoveToDimensioning}
                                    className="w-100 py-3 mb-3"
                                >
                                    <i className="fas fa-ruler-combined mr-2"></i>
                                    Move to Dimensioning
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </div>

                <div>
                    <h4>{t('Installation History')}</h4>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>{t('Date')}</th>
                                <th>{t('User')}</th>
                                <th>{t('Action')}</th>
                                <th>{t('Packing Line')}</th>
                                <th>{t('Details')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {mockHistory.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.date}</td>
                                    <td>{item.user}</td>
                                    <td>{item.action}</td>
                                    <td>{item.action === 'Installed' ? item.machineName : '-'}</td>
                                    <td>{item.details}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={onHide}>
                    {t('Close')}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default PartInfoModal; 